import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c(VSelect,{attrs:{"label":"Quantity Type","items":_vm.quantityTypes},model:{value:(_vm.quantityType),callback:function ($$v) {_vm.quantityType=$$v},expression:"quantityType"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }